import React from 'react';
import Bar from '@splunk/dashboard-visualizations/Bar';

export default () => (
    <Bar
        options={{
            'gridLinesY.showMinorLines': true,
        }}
        encoding={{
            x: 'primary._time',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: '_time', groupby_rank: '0' }, { name: 'count' }, { name: '_span' }],
                    columns: [
                        [
                            '2018-05-02T18:15:46.000-07:00',
                            '2018-05-02T18:15:47.000-07:00',
                            '2018-05-02T18:15:48.000-07:00',
                            '2018-05-02T18:15:49.000-07:00',
                            '2018-05-02T18:15:50.000-07:00',
                        ],
                        ['2', '10', '13', '60', '43'],
                        ['1', '1', '1', '1', '1'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
